/** 来源：foodbuy Progress；value 夹在 0–100 并补齐 progressbar aria 上下界。 */
import type { Tone } from './tones'

const fillToneClasses: Record<Tone, string> = {
  neutral: 'bg-[var(--color-muted)]',
  info: 'bg-[var(--color-primary)]',
  success: 'bg-[var(--color-success)]',
  warning: 'bg-[var(--color-warning)]',
  danger: 'bg-[var(--color-danger)]'
}

export function Progress({ value, label, tone = 'info' }: { value: number; label?: string; tone?: Tone }) {
  const clamped = Math.max(0, Math.min(100, value))
  return (
    <div
      className="h-[var(--track-height)] w-full overflow-hidden rounded-[var(--radius-track)] bg-[var(--color-track)]"
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(clamped)}
    >
      <div className={`h-full rounded-[var(--radius-track)] motion-safe:transition-[width] ${fillToneClasses[tone]}`} style={{ width: `${clamped}%` }} />
    </div>
  )
}
